import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Container } from './styles'

export type BreadCrumb = {
  to?: string
  title: string
}

type BreadCrumbsProps = {
  breadcrumbs: BreadCrumb[]
}

const BreadCrumbs: FC<BreadCrumbsProps> = ({ breadcrumbs }): ReactElement => {
  return (
    <Container className='breadcrumbs'>
      {breadcrumbs.map(breadcrumb => (
        <Link key={breadcrumb.to} to={breadcrumb.to || ''}>{breadcrumb.title}</Link>
      ))}
    </Container>
  )
}

export default BreadCrumbs
